import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { OnetrustSettingsButton } from '@calendly/onetrust/redux'
import _CookieSettingsButton from "styles-CookieSettingsButton.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/landing_page/styles.js?styleId=CookieSettingsButton";


export const CookieSettingsButton = /*#__PURE__*/styled(OnetrustSettingsButton, null, {
  displayName: "CookieSettingsButton",
  styles: _CookieSettingsButton,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown'),
    isDesktopUp: useDeviceType('isDesktopUp')
  })
})
